import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SecurityService } from "../../service/security.service";
import { NotificationService } from "src/app/mobile-application-manager/service/notification.service";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-callback",
  templateUrl: "./callback.component.html",
  styleUrls: ["./callback.component.scss"],
})
export class CallbackComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private securityService: SecurityService,
    private notificationService: NotificationService,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((queryParam) => {
      let token = queryParam["authToken"];
      if (token) {
        localStorage.setItem("authToken", token);
        this.securityService.updateUserInfo({ DRIVER_APP: "ROLE_ADMIN" });
        this.router.navigate(["/mdm/main-dashboard"]);
      } else if (queryParam["error"]) {
        if (queryParam["error"] == "Only authorized users can use mdm") {
          this.notificationService.pushNotification(queryParam["error"]);
          this.securityService.signOut();
          this.router.navigate(["/", "access-denied"]);
        } else {
          this.notificationService.pushNotification(queryParam["error"]);
          this.securityService.signOut();
          this.router.navigate(["/", "login"]);
        }
      } else {
        this.notificationService.pushNotification("Some issue occured while logging in, please try again");
        this.securityService.signOut();
        this.router.navigate(["/", "login"]);
      }
    });
  }
}
